export const DYNAMIC_PROCESSES_EDITOR_PATH = "/dynamic-processes/:id";
